"use strict";

var _regeneratorRuntime = require("/home/cleysonph/playground/TypeScript-Website/node_modules/gatsby/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/cleysonph/playground/TypeScript-Website/node_modules/gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OnigasmModuleFactory = require('./onigasm.js'
/** when TS is compiled to JS, this will mean `lib/onigasm.js` (emitted by `emcc`) */
);

function initModule(_x) {
  return _initModule.apply(this, arguments);
}

function _initModule() {
  _initModule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(bytes) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var _console = console,
                  log = _console.log,
                  warn = _console.warn,
                  error = _console.error;
              OnigasmModuleFactory({
                instantiateWasm: function instantiateWasm(imports, successCallback) {
                  WebAssembly.instantiate(bytes, imports).then(function (output) {
                    successCallback(output.instance);
                  }).catch(function (e) {
                    throw e;
                  });
                  return {};
                }
              }).then(function (moduleH) {
                exports.onigasmH = moduleH;
                resolve();
              });

              if (typeof print !== 'undefined') {
                // can be removed when https://github.com/emscripten-core/emscripten/issues/9829 is fixed.
                // tslint:disable-next-line:no-console
                console.log = log; // tslint:disable-next-line:no-console

                // tslint:disable-next-line:no-console
                console.error = error; // tslint:disable-next-line:no-console

                // tslint:disable-next-line:no-console
                console.warn = warn;
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _initModule.apply(this, arguments);
}

var isInitialized = false;
/**
 * Mount the .wasm file that will act as library's "backend"
 * @param data Path to .wasm file or it's ArrayBuffer
 */

function loadWASM(_x2) {
  return _loadWASM.apply(this, arguments);
}

function _loadWASM() {
  _loadWASM = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var arrayBuffer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isInitialized) {
              _context2.next = 2;
              break;
            }

            throw new Error("Onigasm#init has been called and was succesful, subsequent calls are not allowed once initialized");

          case 2:
            if (!(typeof data === 'string')) {
              _context2.next = 12;
              break;
            }

            _context2.next = 5;
            return fetch(data);

          case 5:
            _context2.next = 7;
            return _context2.sent.arrayBuffer();

          case 7:
            arrayBuffer = _context2.sent;
            _context2.next = 10;
            return initModule(arrayBuffer);

          case 10:
            _context2.next = 18;
            break;

          case 12:
            if (!(data instanceof ArrayBuffer)) {
              _context2.next = 17;
              break;
            }

            _context2.next = 15;
            return initModule(data);

          case 15:
            _context2.next = 18;
            break;

          case 17:
            throw new TypeError("Expected a string (URL of .wasm file) or ArrayBuffer (.wasm file itself) as first parameter");

          case 18:
            isInitialized = true;

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadWASM.apply(this, arguments);
}

exports.loadWASM = loadWASM;